import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import hiddenDom from '../../hiddenDom.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  components: {
    hiddenDom
  },
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  watch: {},
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters('operateTask', ['checkInList', 'isAward', 'isClickTasked', 'isOperateFailed'])), mapGetters('login', ['isLogin'])), mapState('url', ['isTaskOperate'])), {}, {
    visibleOperateDom() {
      return this.isTaskOperate && this.checkInList.history && this.checkInList.history.length > 0;
    }
  }),
  async created() {
    if (this.index === 0 && this.isTaskOperate && this.isLogin) {
      await this.getCheckIn();
    }
    if (this.index === 0) {
      this.visibleOperateDom && this.addTask();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('operateTask', ['addTask', 'getCheckIn'])), {}, {
    contentShow() {
      // 如果已经开奖成功，没有点击查看，不再继续执行计数
      if (this.isAward && !this.isClickTasked && !this.isOperateFailed) {
        return;
      }
      if (this.index !== 0) {
        this.visibleOperateDom && this.addTask();
      }
    }
  })
};